import { createAsyncThunk } from '@reduxjs/toolkit';
import { CalendarEvent, IBaseQuery, IBookingObj, PaginatedType } from '@types';
import { axiosErrorHandler } from '@api/config';
import {
    getAtsUsersRequest,
    getBookingReuest,
    getCallsRequest,
    getPromoutersReuest,
    getReservedTablesRequest,
} from '@api/services/bookingApi';
import {
    IAtsUsersQuery,
    IBookingQuery,
    ICallsQuery,
    IPromouter,
    IReservedTablesQuery,
} from '@api/services/bookingApi/types';
import { IAtsUserData, ICalls, ITableBooking } from '@entities/booking/types';
import { transformTableDataToEvents } from '@utils/functions/transformTableDataToEEvents';

export const getBookins = createAsyncThunk<
    PaginatedType<IBookingObj>,
    { shop_id: number; params: IBookingQuery }
>(
    '@@booking/getBookins',
    async (
        { shop_id, params }: { shop_id: number; params: IBookingQuery },
        { rejectWithValue }
    ) => {
        try {
            const { data } = await getBookingReuest(shop_id, params);
            return data;
        } catch (err) {
            return rejectWithValue(axiosErrorHandler(err));
        }
    }
);

export const getPromouters = createAsyncThunk<
    PaginatedType<IPromouter>,
    { shop_id: number; params: IBaseQuery }
>(
    '@@booking/getPromouter',
    async (
        { shop_id, params }: { shop_id: number; params: IBaseQuery },
        { rejectWithValue }
    ) => {
        try {
            const { data } = await getPromoutersReuest(shop_id, params);
            return data;
        } catch (err) {
            return rejectWithValue(axiosErrorHandler(err));
        }
    }
);

export const getCalls = createAsyncThunk<
    PaginatedType<ICalls>,
    { shop_id: number; params: ICallsQuery }
>(
    '@@booking/getCalls',
    async (
        { shop_id, params }: { shop_id: number; params: ICallsQuery },
        { rejectWithValue }
    ) => {
        try {
            const { data } = await getCallsRequest(shop_id, params);
            return data;
        } catch (err) {
            return rejectWithValue(axiosErrorHandler(err));
        }
    }
);

export const getAtsUsers = createAsyncThunk<
    IAtsUserData[],
    { shop_id: number; params: IAtsUsersQuery }
>(
    '@@booking/getAtsUsers',
    async (
        { shop_id, params }: { shop_id: number; params: IAtsUsersQuery },
        { rejectWithValue }
    ) => {
        try {
            const { data } = await getAtsUsersRequest(shop_id, params);
            return data;
        } catch (err) {
            return rejectWithValue(axiosErrorHandler(err));
        }
    }
);
export const getReservedTables = createAsyncThunk<
    { data: ITableBooking[]; events: CalendarEvent[] },
    { shop_id: number; params: IReservedTablesQuery }
>(
    '@@booking/getReservedTables',
    async (
        { shop_id, params }: { shop_id: number; params: IReservedTablesQuery },
        { rejectWithValue }
    ) => {
        try {
            const { data } = await getReservedTablesRequest(shop_id, params);
            const events = transformTableDataToEvents(data);
            return { data, events };
        } catch (err) {
            return rejectWithValue(axiosErrorHandler(err));
        }
    }
);
